<template>
  <div class="mm-row-block">
    <el-form ref="form" :model="form" :rules="rules" label-width="180px" label-position="left">

      <div class="form-isheader-group">
        <div class="group-title">
          <h3>基本資料</h3>
        </div>
        <div class="form-isheader-group-content">
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="公司名稱" prop="name">
                <el-input disabled="" v-model="data.name">
                    <el-button slot="append" @click="copyText(data.name)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="公司編號" prop="company_num">
                <el-input disabled="" v-model="data.company_num">
                    <el-button slot="append" @click="copyText(data.company_num)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="商業登記證號碼" prop="company_card">
                <el-input disabled="" v-model="data.company_card">
                    <el-button slot="append" @click="copyText(data.company_card)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="商業登記證號碼有效日期" prop="company_card_date">
                <el-input disabled="" v-model="data.company_card_date">
                    <el-button slot="append" @click="copyText(data.company_card_date)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="業務性質" prop="company_type">
                <el-input disabled="" v-model="data.company_type">
                    <el-button slot="append" @click="copyText(data.company_type)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="公司電話號碼" prop="phone">
                <el-input disabled="" v-model="data.phone">
                    <el-button slot="append" @click="copyText(data.phone)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="公司電郵" prop="email">
                <el-input disabled="" v-model="data.email">
                    <el-button slot="append" @click="copyText(data.email)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="MSO 編號" prop="mso_num">
                <el-input disabled="" v-model="data.mso_num">
                    <el-button slot="append" @click="copyText(data.mso_num)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="MSO有效日期" prop="mso_num_date">
                <el-input disabled="" v-model="data.mso_num_date">
                    <el-button slot="append" @click="copyText(data.mso_num_date)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </div>

      </div>
      <el-card class="box-card mb10" shadow="never">
        <div slot="header" class="clearfix">
          <h3>股東 及 董事</h3>
        </div>
        <div class="text item">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item label="股東姓名" required>
                <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                  <el-input disabled="" v-model="data.stockholder[0].name">
                    <el-button slot="append" @click="copyText(data.stockholder[0].name)" type="primary" icon="el-icon-document-copy"></el-button>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item label="董事姓名" required>
                <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                  <el-input disabled="" v-model="data.director[0].name">
                    <el-button slot="append" @click="copyText(data.director[0].name)" type="primary" icon="el-icon-document-copy"></el-button>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <el-card class="box-card mb10" shadow="never">
        <div slot="header" class="clearfix">
          <h3>獲授權人</h3>
        </div>
        <div class="text item">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item label="姓名" required>
                <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                  <el-input disabled="" v-model="data.authorizer[0].name">
                    <el-button slot="append" @click="copyText(data.authorizer[0].name)" type="primary" icon="el-icon-document-copy"></el-button>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item label="電話號碼" required>
                <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                  <el-input disabled="" v-model="data.authorizer[0].phone">
                    <el-button slot="append" @click="copyText(data.authorizer[0].phone)" type="primary" icon="el-icon-document-copy"></el-button>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

        </div>
      </el-card>
      <div class="form-isheader-group">
        <div class="group-title">
          <h3>會員文件</h3>
        </div>
        <div class="form-isheader-group-content">
          <el-upload disabled action="#" :file-list="files1" list-type="picture-card" :auto-upload="false" :on-preview="viewpic" :on-remove="delpic">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="showpicbox" :append-to-body="true">
            <img width="100%" :src="showpicurl" alt="">
          </el-dialog>

        </div>
      </div>
      <div class="form-isheader-group">
        <div class="group-title">
          <h3>審查結果 Name Screening Result</h3>
        </div>
        <div class="form-isheader-group-content">
          <div style="margin-bottom: 20px;">
            <div class="group-sub-title">
              <h3>OFAC</h3>
            </div>
            <el-table empty-text="暫無數據" :data="examinedata" border :header-cell-style="{background:'#FAFAFA'}">
              <el-table-column label="Name" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Name</div>
                  <span>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Address" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Address</div>
                  <span>{{scope.row.address}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Type" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Type</div>
                  <span>{{scope.row.type}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Program(s)" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Program(s)</div>
                  <span>{{scope.row.program}}</span>
                </template>
              </el-table-column>
              <el-table-column label="List" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">List</div>
                  <span>{{scope.row.list}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Score" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Score</div>
                  <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                  <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                  <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                </template>
              </el-table-column>
              <el-table-column label="url" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">url</div>
                  <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                </template>
              </el-table-column>
              <el-table-column label="Query Time" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Query Time</div>
                  <span v-if="scope.row.addtime">{{scope.row.addtime}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-bottom: 20px;">
            <div class="group-sub-title">
              <h3>UNSC</h3>
            </div>
            <el-table empty-text="暫無數據" :data="examinedataxml" border :header-cell-style="{background:'#FAFAFA'}">
              <el-table-column label="Name" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Name</div>
                  <span>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Type" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">type</div>
                  <span>{{scope.row.type}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Design" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">design</div>
                  <span>{{scope.row.design}}</span>
                </template>
              </el-table-column>

              <el-table-column label="Date" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">date</div>
                  <span>{{scope.row.date}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Score" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Score</div>
                  <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                  <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                  <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Url" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">url</div>
                  <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                </template>
              </el-table-column>
              <el-table-column label="Query Time" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Query Time</div>
                  <span>{{scope.row.addtime}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-upload disabled action="#" :file-list="files2" list-type="picture-card" :auto-upload="false" :on-preview="viewpic" :on-remove="delpic">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="showpicbox" :append-to-body="true">
            <img width="100%" :src="showpicurl" alt="">
          </el-dialog>
        </div>
      </div>
      <!-- <div class="form-submit">
        <el-button type="primary">保存</el-button>
      </div> -->
    </el-form>
  </div>

</template>

<script>
export default {
  props: ['data'],
  name: "connoisseur",
  data () {
    return {
      showpicurl: '',
      showpicbox: false,
      value1: 0,
      ordertype: -1,
      form: {},
      files1: [],
      files2: [],
      examinedata:[],
      examinedataxml:[],
      rules: {
        phone: [{
          required: true,
          message: '請輸入電話號碼',
        },
        {
          pattern: /^[0-9]+$/,
          message: '只能輸入數字'
        },
        ],
        name: [{
          required: true,
          message: '请输入会员姓名',
        },
        {
          pattern: /^[\S]+$/,
          message: '只能輸入可見字符'
        },
        ],
        country_id: [{
          required: true,
          message: '请选择会员国籍',
        }
        ],
        email: [
          {
            type: 'email',
            message: '請輸入正確的郵箱地址',
            trigger: 'blur'
          }
        ]



      }
    }
  },
  methods: {
    delpic (file, fileList) {
      console.log(file, fileList);
    },
    viewpic (file) {
      this.showpicurl = file.url;
      this.showpicbox = true;
    },
    copyText (text) {
      const oInput = document.createElement('input')
      oInput.value = text;
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('Copy')
      // 提醒信息
      this.$notify({
        message: '複製成功',
        type: 'success',
        duration: 3000,
        offset: 70
      });
      oInput.remove()
    },
  },
  created () {
    this.examinedata = this.data.examinedata;
    this.examinedataxml = this.data.examinedataxml;
    this.data.files.map((v) => {
      if (v.type == 1) {
        let file = {
          name: '',
          url: this.apiurl + v.fileurl
        }
        this.files1.push(file);
      } else if (v.type == 2) {
        let file = {
          name: '',
          url: this.apiurl + v.fileurl
        }
        this.files2.push(file);
      }
    })
  }
}
</script>

<style scoped>
.mb10{
	margin-bottom: 10px;
}
.flex50 {
  flex: 0 50%;
}
</style>
